var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToolbarTriangleDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.39 6.512l2.96-3.7A.5.5 0 006.96 2H1.04a.5.5 0 00-.39.812l2.96 3.7c.2.25.58.25.78 0z",
    fill: "#fff"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOCIgaGVpZ2h0PSI4IiB2aWV3Qm94PSIwIDAgOCA4IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogIDxwYXRoIGQ9Ik00LjM5MDQzIDYuNTExOTZMNy4zNTAxMiAyLjgxMjM1QzcuNjEyMDMgMi40ODQ5NyA3LjM3ODk0IDIgNi45NTk2OSAyTDEuMDQwMzEgMkMwLjYyMTA2MSAyIDAuMzg3OTc0IDIuNDg0OTYgMC42NDk4OCAyLjgxMjM1TDMuNjA5NTcgNi41MTE5NkMzLjgwOTczIDYuNzYyMTYgNC4xOTAyNyA2Ljc2MjE2IDQuMzkwNDMgNi41MTE5NloiIGZpbGw9IndoaXRlIiAvPgo8L3N2Zz4KICA=";
export { SvgToolbarTriangleDown as ReactComponent };